import xlsx from "json-as-xlsx";
import { TIME_INTERVALS } from "@follaw-fr/constants/time-interval";
import { getFormattedDate } from "@follaw-fr/utils/date.utils";

/**
 * Common logic related to time curves.
 * @param {Ref} timeCurve - Reactive data for the time curve.
 * @param {Ref} timeCurveInterval - The interval of the time curve.
 * @param {Ref} timeCurveTopDate - The selected date for zooming in.
 * @param {Ref}  timeCurveTopArticlesFilters - Filters for top articles.
 * @param {Ref}  timeCurveTopPublicationsFilters - Filters for top publications.
 * @param {Function} fetchTimeCurve - Function to reload the time curve data.
 */

export function useTimeCurve({
  timeCurve,
  timeCurveInterval,
  timeCurveTopDate,
  timeCurveTopArticlesFilters,
  timeCurveTopPublicationsFilters,
  fetchTimeCurve,
}) {
  const intervalsOptions = [
    { label: "Mois", value: TIME_INTERVALS.MONTH },
    { label: "Jour", value: TIME_INTERVALS.DAY },
    { label: "Heure", value: TIME_INTERVALS.HOUR },
  ];

  const changeInterval = (newInterval) => {
    timeCurveInterval.value = newInterval;
    timeCurveTopDate.value = null;
    fetchTimeCurve();
  };

  const closeZoom = () => {
    timeCurveTopDate.value = null;
  };

  const downloadAsExcel = () => {
    const intervalName = intervalsOptions.find(
      (elem) => elem.value === timeCurveInterval.value
    ).label;

    const dataAsJson = [
      {
        sheet: "Export publications",
        columns: [
          { label: "Réseau social", value: "social" },
          { label: intervalName, value: "time" },
          { label: "Nombre de publications", value: "nbPublications" },
        ],
        content: Object.entries(timeCurve.value).flatMap(([social, data]) =>
          Object.entries(data).map(([key, val]) => ({
            social: social,
            time: getFormattedDate(key, timeCurveInterval.value),
            nbPublications: val,
          }))
        ),
      },
    ];

    xlsx(dataAsJson, {
      fileName: "Export publications",
    });
  };

  const updateTopDate = (newDate) => {
    timeCurveTopDate.value = newDate;
  };

  const updateTopArticlesFilters = (articlesFilters) => {
    timeCurveTopArticlesFilters.value = articlesFilters;
  };

  const updatePublicationsFilters = (publicationsFilters) => {
    timeCurveTopPublicationsFilters.value = publicationsFilters;
  };

  return {
    intervalsOptions,
    changeInterval,
    closeZoom,
    downloadAsExcel,
    updateTopDate,
    updateTopArticlesFilters,
    updatePublicationsFilters,
  };
}
